import React, { Component } from 'react';
import classnames from 'classnames';
import Draggable from 'react-draggable';
import { findDOMNode } from 'react-dom';

export default class ShowShape extends Component {
  // [2026-06-29] ❺ 重なったNoはクリックで一覧を出して選ばせる
  openMarkerById(id) {
    window._tmShapeClickLock = true;
    setTimeout(() => { window._tmShapeClickLock = false; }, 200);
    window._tmPendingCardId = String(id);
    $(`div.animation-marker-${id}`).trigger('click');
  }
  handleNoClick = (e) => {
    e.stopPropagation();
    if (window._tmShapeClickLock) return;
    const px = e.clientX, py = e.clientY;
    const hit = [];
    document.querySelectorAll('.numerical-order-container').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.width > 0 && px >= r.left && px <= r.right && py >= r.top && py <= r.bottom) {
        const m = el.closest('.show-mark-shape');
        const id = m && (m.className.match(/marker-(\d+)/) || [])[1];
        const noEl = el.querySelector('.comment-no');
        if (id) hit.push({ id, no: noEl ? noEl.textContent.trim() : id });
      }
    });
    document.getElementById('tm-overlap-picker')?.remove();
    if (hit.length <= 1) { this.openMarkerById(this.props.marker_id); return; }
    window._tmShapeClickLock = true;
    setTimeout(() => { window._tmShapeClickLock = false; }, 200);
    const box = document.createElement('div');
    box.id = 'tm-overlap-picker';
    box.style.cssText = 'position:fixed;z-index:2147483646;background:#fff;border:1px solid #888;border-radius:8px;box-shadow:0 4px 16px rgba(0,0,0,.3);padding:6px;max-height:240px;overflow:auto;display:flex;flex-wrap:wrap;gap:6px;max-width:220px';
    box.style.left = Math.min(px, window.innerWidth - 230) + 'px';
    box.style.top = Math.min(py, window.innerHeight - 250) + 'px';
    hit.forEach(h => {
      const b = document.createElement('button');
      b.textContent = h.no;
      b.style.cssText = 'width:36px;height:36px;border-radius:50%;border:2px solid #d33;background:#fff;color:#d33;font-weight:bold;cursor:pointer';
      b.onclick = (ev) => { ev.stopPropagation(); box.remove(); this.openMarkerById(h.id); };
      box.appendChild(b);
    });
    document.body.appendChild(box);
    const close = (ev) => { if (!box.contains(ev.target)) { box.remove(); document.removeEventListener('mousedown', close, true); } };
    setTimeout(() => document.addEventListener('mousedown', close, true), 0);
  }

  handleStop =(e, ui)=> {
    const { x, y, onMarkerUpdationCalled, marker_id, image, updateMakerShow } = this.props;
    const playerRect = findDOMNode(image).getBoundingClientRect();
    const newX = (playerRect.width * x) / 10000 + playerRect.left;
    const newY = (playerRect.height * y) / 10000 + playerRect.top;
    const updateX = ((newX + ui.lastX) - playerRect.left) / playerRect.width * 10000;
    const updateY = ((newY + ui.lastY) - playerRect.top) / playerRect.height * 10000;
    const data = {
      animation_marker: {
        x: updateX,
        y: updateY
      }
    };
    updateMakerShow(updateX, updateY, marker_id)
    onMarkerUpdationCalled(data, marker_id)
  }
  render() {
    const { x, y, width, height, shape, marker_id, borderColor, index } = this.props;
    switch (shape) {
      case 'point':
        return (
          <Draggable
            position={{ x: 0, y: 0 }}
            disabled={true}
            onStop={this.handleStop}>
            <div className={`show-mark-shape marker-${marker_id}`} style={{ left: `${x / 100}%`, top: `${y / 100}%` }} data={marker_id}>
              <div className="border-none numerical-order-container d-flex justify-content-center align-items-center cursor-pointer" style={{backgroundColor: borderColor}}
                   onClick={this.handleNoClick}
                   onMouseDown={(e) => e.stopPropagation()}
              >
                <div className="comment-no">
                  {index}
                </div>
              </div>
            </div>
          </Draggable>
        )
      case 'rect':
        return (
          <Draggable
            position={{ x: 0, y: 0 }}
            disabled={true}
            onStop={this.handleStop}>
            <div className={`show-mark-shape marker-${marker_id}`} style={{ left: `${x / 100}%`, top: `${y / 100}%`, width: `${width / 100}%`, height: `${height / 100}%`, pointerEvents: 'none' }} data={marker_id}>
              <div className="red-rect" style={{backgroundColor: "rgba(255, 239, 135, 0.2)", borderColor: borderColor, pointerEvents: 'none'}}>
                <div className="border-none numerical-order-container d-flex justify-content-center align-items-center m-1 cursor-pointer"
                  style={{backgroundColor: borderColor, pointerEvents: 'auto'}}
                  onClick={this.handleNoClick}>
                  <div className="comment-no">
                    {index}
                  </div>
                </div>
              </div>
            </div>
          </Draggable>
        )
      case 'draw':
        return (
          <Draggable
            position={{ x: 0, y: 0 }}
            disabled={true}
            onStop={this.handleStop}>
            <div className={`show-mark-shape marker-${marker_id}`} style={{ left: `${x / 100}%`, top: `${y / 100}%`, width: `${width / 100}%`, height: `${height / 100}%` }} data={marker_id}>
              <div className="border-none numerical-order-container d-flex justify-content-center align-items-center m-1 cursor-pointer" style={{backgroundColor: borderColor}}
                onClick={this.handleNoClick}>
                  <div className="comment-no">
                    {index}
                  </div>
                </div>
            </div>
          </Draggable>
        )
    }
  }
}
